import getMovieUrl from "./getMovieUrl"

const getPerformanceUrl = (id, routeMovie, currentLang) => {
    const movieUrl = getMovieUrl(routeMovie, currentLang)
    if (movieUrl) {
        const separator = movieUrl.includes("?") ? "&" : "?"
        return `${movieUrl}${separator}performance_id=${id}`
    }
    return null
}

export default getPerformanceUrl